import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";
import { AuthenticationStoreService } from "../stores/staybloom/authenticationStore/authenticationStore.services";
import { RoleUiEnum } from "../com/staybloom/common/uiproto/roleUiProto";

export const ChainLevelGuard: CanActivateChildFn = async (route, state) => {
  const authenticationStoreService = inject(AuthenticationStoreService);
  const router = inject(Router);

  if (
    !authenticationStoreService.userAccess ||
    authenticationStoreService.userAccess.length === 0
  ) {
    try {
      await authenticationStoreService.loadUserAuthenticatedAccess();
    } catch (error) {
      console.error("Failed to load user access data:", error);
      router.navigate(["unit/properties"]);
      return false;
    }
  }
  const hasAccess = authenticationStoreService.userAccess?.some((data) =>
    data?.role?.includes(RoleUiEnum.SUPER_USER)
  );
  if (!hasAccess) {
    document
      .querySelector(".btn_containers_icons a:first-child")
      .classList.add("disable");
    router.navigate(["unit/properties"]);
    return false;
  }

  return true;
};
